
import mgPageData from "../../data/managedServices";
import aboutUsData from "../../data/aboutUs";
import Calculator from "../../components/vpc/calculator.vue";
import Customers from "../../components/vpc/customers.vue";
import possibility from "../../components/vpc/possibility.vue";
import Plans from "../../components/vps/plans.vue";
import Benefits from "../../components/vpc/Benefits.vue";
import Modal from "../../components/rebranding/modal/Modal.vue";
import levelsServices from "../../components/managedServices/levelsServices.vue";
import issues from "../../components/managedServices/issues.vue";
import os from "../../components/managedServices/os.vue";

import Slider from "../../components/customers/slider.vue";
import Categories from "../../components/customers/categories.vue";

export default {
  components: {
    Calculator,
    possibility,
    Customers,
    Plans,
    Benefits,
    Modal,
    levelsServices,
    issues,
    os,
    Slider,
    Categories,
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "درباره ما - آبالون",
      meta: [
        {
          name: "description",
          content:
            "شرکت «راهکار آینده زمین» در سال 1393 با نام تجاری «آبالون» به ثبت رسید و با به کار گیری سرویس‌های مبتنی بر «ابر» به بهبود عملکرد کسب و کارهای آنلاین کمک می کند.",
        },
        {
          "http-equiv": "X-UA-Compatible",
          content: "IE=edge",
        },
        {
          property: "og:site_name",
          content: " آبالون - ارائه دهنده سرور مجازی (VPS) و سرور ابری",
        },
        {
          name: "keywords",
          content: "درباره ما",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/aboutus",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "درباره ما - آبالون",
        },
        {
          property: "og:description",
          content:
            "شرکت «راهکار آینده زمین» در سال 1393 با نام تجاری «آبالون» به ثبت رسید و با به کار گیری سرویس‌های مبتنی بر «ابر» به بهبود عملکرد کسب و کارهای آنلاین کمک می کند.",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/aboutus",
        },
        {
          name: "twitter:creator",
          content: "@themetrades",
        },
        {
          name: "twitter:title",
          content: "Abalon Cloud | داستان ما",
        },
        {
          name: "twitter:description",
          content:
            "شرکت «راهکار آینده زمین» در سال 1393 با نام تجاری «آبالون» به ثبت رسید و با به کار گیری سرویس‌های مبتنی بر «ابر» به بهبود عملکرد کسب و کارهای آنلاین کمک می کند.",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/aboutus",
        },
      ],
    };
  },
  data() {
    return {
      title: "آبالون: ارائه دهنده سرویس‌های ابری",
      FormTitle: "ثبت درخواست ارتباط با واحد فروش",
      benefits: mgPageData.benefits,
      dataBlog: mgPageData.dataBlog,
      questions: mgPageData.questions,
      uses: mgPageData.uses,
      activeSection: "",
      operationSystems: mgPageData.operationSystems,
      ranges: mgPageData.ranges,
      mgUses: mgPageData.mgUses,

      story: aboutUsData.story,
      results: aboutUsData.results,
      category: "mali",
    };
  },
  mounted() {},
  methods: {
    changeCategory(payload) {
      this.category = payload;
    },
    spliceNumber(number) {
      if (number != null) {
        number = Math.round(number);
        return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
    },
  },
};
